var _rect, _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddItemsLimitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 68,
    viewBox: "0 0 65 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_4149_99001)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0418 16.167H24.021V23.292H18.6252C17.7737 23.292 17.0835 24.0009 17.0835 24.8753V47.8337H27.1043V40.7087H30.9585V47.8337H46.3752C47.2266 47.8337 47.9168 47.1248 47.9168 46.2503V37.542H40.9793V30.417H34.0418V16.167ZM27.4157 22.9723V19.6534H30.6472V22.9723H27.4157ZM20.4724 30.1032V26.7725H23.7154V30.1032H20.4724ZM27.4099 37.2282V33.8975H30.6529V37.2282H27.4099ZM20.4677 41.0177V44.3581H23.7202V41.0177H20.4677ZM20.4724 33.8975V37.2258H23.7131V33.8975H20.4724ZM27.4099 26.7725V30.1032H30.6529V26.7725H27.4099ZM34.3427 41.0176V44.358H37.5952V41.0176H34.3427ZM41.2802 44.3581V41.0177H44.5326V44.3581H41.2802ZM34.3486 33.8988V37.227H37.5892V33.8988H34.3486Z",
    fill: "#1A1B1D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_4149_99001)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0418 62H24.021V59.75H18.6252C17.7737 59.75 17.0835 59.5261 17.0835 59.25V52H27.1043V54.25H30.9585V52H46.3752C47.2266 52 47.9168 52.2239 47.9168 52.5V55.25H40.9793V57.5H34.0418V62ZM27.4157 59.851V60.899H30.6472V59.851H27.4157ZM20.4724 57.5991V58.6509H23.7154V57.5991H20.4724ZM27.4099 55.3491V56.4009H30.6529V55.3491H27.4099ZM20.4677 54.1524V53.0976H23.7202V54.1524H20.4677ZM20.4724 56.4009V55.3499H23.7131V56.4009H20.4724ZM27.4099 58.6509V57.5991H30.6529V58.6509H27.4099ZM34.3427 54.1524V53.0976H37.5952V54.1524H34.3427ZM41.2802 53.0976V54.1524H44.5326V53.0976H41.2802ZM34.3486 56.4005V55.3495H37.5892V56.4005H34.3486Z",
    fill: "#1A1B1D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.397 49.897 63.5 32.5 63.5C15.103 63.5 1 49.397 1 32C1 14.603 15.103 0.5 32.5 0.5C49.897 0.5 64 14.603 64 32Z",
    stroke: "white",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 8C45.4157 10.5654 47.4346 12.5843 50 13.5C47.4346 14.4157 45.4157 16.4346 44.5 19C43.5843 16.4346 41.5654 14.4157 39 13.5C41.5654 12.5843 43.5843 10.5654 44.5 8Z",
    fill: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0357 6C53.5411 7.41598 54.6555 8.53031 56.0714 9.03571C54.6555 9.54112 53.5411 10.6555 53.0357 12.0714C52.5303 10.6555 51.416 9.54112 50 9.03571C51.416 8.53031 52.5303 7.41598 53.0357 6Z",
    fill: "#1A1B1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4634 16.5C51.9689 17.916 53.0832 19.0303 54.4992 19.5357C53.0832 20.0411 51.9689 21.1555 51.4634 22.5714C50.958 21.1555 49.8437 20.0411 48.4277 19.5357C49.8437 19.0303 50.958 17.916 51.4634 16.5Z",
    fill: "#1A1B1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4149_99001",
    x: 8,
    y: 45,
    width: 49,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_4149_99001"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4149_99001",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33 32) rotate(90) scale(28)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItemsLimitation);
export default __webpack_public_path__ + "static/media/add-items-limitation.860849b2bfa2e64ff066a5a7a78ccab3.svg";
export { ForwardRef as ReactComponent };